import { render, staticRenderFns } from "./UpdateGroupDialog.vue?vue&type=template&id=4417fe06&scoped=true"
import script from "./UpdateGroupDialog.vue?vue&type=script&lang=js"
export * from "./UpdateGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4417fe06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4417fe06')) {
      api.createRecord('4417fe06', component.options)
    } else {
      api.reload('4417fe06', component.options)
    }
    module.hot.accept("./UpdateGroupDialog.vue?vue&type=template&id=4417fe06&scoped=true", function () {
      api.rerender('4417fe06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/UpdateGroupDialog.vue"
export default component.exports